'use es6';

export default {
  INITIAL: 'initial',
  SAVING: 'saving'
};